import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ToastrModule } from 'ngx-toastr';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { AppRoutingModule } from './app-routing.module';
import { HttpRequestInterceptor } from './_shared/interceptors/http-request.interceptor';
import { HttpErrorResponseInterceptor } from './_shared/interceptors/http-error-response.interceptor';

import { AppComponent } from './app.component';
import { SetComponent } from './set/set.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { AuthenticatedLayoutComponent } from './_shared/components/authenticated-layout/authenticated-layout.component';

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { ModalDirective } from './_shared/directives/modal.directive';
// import { ViewUserComponent } from './users/user-management1/view-user/view-user.component';
// import { EditUserComponent } from './users/user-management1/edit-user/edit-user.component';
import { CreateUserComponent } from './users/user-management1/create-user/create-user.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxPaginationModule } from 'ngx-pagination';
import { BsModalRef, ModalModule } from 'ngx-bootstrap/modal';


import { NgxEchartsModule } from 'ngx-echarts';



@NgModule({
  declarations: [
    AppComponent,
    SignInComponent,
    SetComponent,
    AuthenticatedLayoutComponent,
    ModalDirective,
    // ViewUserComponent,
    // EditUserComponent,
    CreateUserComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxDatatableModule,
    NgxPaginationModule,
    BrowserAnimationsModule,
     ToastrModule.forRoot({
      timeOut: 2000,
      newestOnTop: true,
      preventDuplicates: true
    }),
    BsDatepickerModule.forRoot(),
    TabsModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    ModalModule.forRoot(),

    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA],

  providers: [
    {provide:BsModalRef},
    { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorResponseInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
